'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.File = undefined;

var _sheet = require('./sheet');

var _templates = require('./templates');

var templates = _interopRequireWildcard(_templates);

var _reftable = require('./reftable');

var _xmlWorkbook = require('./xmlWorkbook');

var _xmlContentTypes = require('./xmlContentTypes');

var _xmlStyle = require('./xmlStyle');

var _jszip = require('jszip');

var _jszip2 = _interopRequireDefault(_jszip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

let File = exports.File = class File {

  constructor() {
    this.sheet = {};
    this.sheets = [];
    this.definedNames = [];

    this.styles = new _xmlStyle.XstyleSheet({});
  }
  addSheet(name) {
    if (this.sheet[name]) {
      throw new Error(`duplicate sheet name ${ name }.`);
    }
    const sheet = new _sheet.Sheet({
      name: name,
      file: this,
      selected: this.sheets.length === 0
    });
    this.sheet[name] = sheet;
    this.sheets.push(sheet);
    return sheet;
  }
  saveAs() {
    let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nodebuffer';

    const parts = this.makeParts();
    const zip = new _jszip2.default();
    for (const key of Object.keys(parts)) {
      zip.file(key, parts[key]);
    }
    if (type === 'blob' || type === 'base64') {
      return zip.generateAsync({ type: type });
    } else {
      return zip.generateNodeStream({ type: 'nodebuffer', streamFiles: true });
    }
  }
  makeParts() {
    const parts = {};
    const refTable = new _reftable.RefTable();
    const types = (0, _xmlContentTypes.makeXTypes)();
    const workbook = (0, _xmlWorkbook.makeXworkbook)();

    this.styles.reset();

    let i = 1;
    const sheets = new _xmlWorkbook.Xsheets();
    for (const sheet of this.sheets) {
      const xSheet = sheet.makeXSheet(refTable, this.styles);
      types.children.push(new _xmlContentTypes.XOverride({
        PartName: `/xl/worksheets/sheet${ i }.xml`,
        ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml'
      }));
      sheets.children.push(new _xmlWorkbook.Xsheet({
        name: sheet.name,
        sheetId: i,
        'r:id': `rId${ i }`,
        state: 'visible'
      }));
      parts[`xl/worksheets/sheet${ i }.xml`] = xSheet.render();
      i++;
    }
    workbook.children.push(sheets);

    parts['xl/workbook.xml'] = workbook.render();
    parts['_rels/.rels'] = templates.DOT_RELS;
    parts['docProps/app.xml'] = templates.DOCPROPS_APP;
    parts['docProps/core.xml'] = templates.DOCPROPS_CORE;
    parts['xl/theme/theme1.xml'] = templates.XL_THEME_THEME;

    parts['xl/sharedStrings.xml'] = refTable.makeXsst().render();
    parts['xl/_rels/workbook.xml.rels'] = (0, _xmlWorkbook.makeWorkbookRels)(this.sheets.length).render();
    parts['[Content_Types].xml'] = types.render();
    parts['xl/styles.xml'] = this.styles.render();

    return parts;
  }
};